export default (state = 'ALL', action = {}) => {
    if (action.type === 'PRACTICE_QUESTION_FILTER_CHANGE') {
        return action.payload;
    }
    return state;
};